/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const DatasetPostSchema = z.strictObject({
  identifier: z.string(),
  name: z.string(),
  description: z.string(),
  database: z.string(),
  schema: z.string(),
  extensions: z.optional(z.array(z.string())),
  rawSizeMb: z.string(),
  finalSizeMb: z.string(),
  importSizeMb: z.string(),
  visible: z.boolean(),
  categoryId: ZodTypes.Id,
});

export const AdminDatasetPost = {
  id: 'admin-dataset.post',
  tag: 'Admin',
  summary: 'Admin Create Dataset',
  description: 'Create Dataset',
  method: 'post',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => '/administration/dataset',
  request: {
    body: {
      content: {
        'application/json': {
          schema: DatasetPostSchema,
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
